import { Button, Select, Flex, Text } from "@chakra-ui/react";
import React from "react";

export function CustomPagination({
  pageSize,
  onPageSizeChange,
  current,
  onPageChange,
  total,
}) {
  const totalPages = Math.ceil(total / pageSize);

  return (
    <Flex mt={5} alignItems="center" justifyContent="center">
      <Select
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        width="80px"
        mr={4}
      >
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={30}>30</option>
        <option value={50}>50</option>
      </Select>

      <Button
        onClick={() => onPageChange(current - 1)}
        isDisabled={current === 1}
        mr={4}
      >
        {"<"}
      </Button>

      <Text mx={4}>{`Page ${current} of ${totalPages}`}</Text>

      <Button
        onClick={() => onPageChange(current + 1)}
        isDisabled={current === totalPages}
      >
        {">"}
      </Button>
    </Flex>
  );
}
